import React from 'react';

import { ReactComponent as Icon } from '../../../../assets/icons/arrow-left.svg';

export const ArrowLeftIcon = (props: any) => {
    return <Icon {...props} className={props.className} alt="arrow-left" />;
};
